/* /assets/article-editorial.js
   Editorial article page: copy-link share button and gallery features
   that open in the theme's PhotoSwipe (same UI as product zoom). */
(function () {
  'use strict';

  if (customElements.get('article-editorial')) return;

  class ArticleEditorial extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-copy-link]').forEach((btn) => {
        btn.addEventListener('click', () => this.copy(btn));
      });

      this.querySelectorAll('[data-gallery]').forEach((gallery) => this.initGallery(gallery));

      this.bleeds = Array.from(this.querySelectorAll('.ar-feature--bleed'));
      if (this.bleeds.length) {
        this.layoutBleeds = this.layoutBleeds.bind(this);
        this.layoutBleeds();
        window.addEventListener('resize', this.layoutBleeds);
        window.addEventListener('load', this.layoutBleeds);
      }
    }

    disconnectedCallback() {
      if (this.layoutBleeds) window.removeEventListener('resize', this.layoutBleeds);
    }

    /* Full-bleed figures: measure where the figure would naturally sit,
       then pull it back to the viewport's left edge and stretch it to the
       viewport's width (clientWidth, so the scrollbar isn't counted). */
    layoutBleeds() {
      const width = document.documentElement.clientWidth;
      this.bleeds.forEach((el) => {
        el.style.removeProperty('--ar-bleed-left');
        el.style.removeProperty('--ar-bleed-width');
        const left = el.getBoundingClientRect().left;
        el.style.setProperty('--ar-bleed-left', `${-left}px`);
        el.style.setProperty('--ar-bleed-width', `${width}px`);
        el.style.setProperty('--ar-bleed-inset', `${left}px`);
      });
    }

    copy(btn) {
      const url = btn.dataset.copyLink || window.location.href;
      const done = () => {
        btn.setAttribute('data-copied', '');
        window.setTimeout(() => btn.removeAttribute('data-copied'), 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => this.fallbackCopy(url, done));
      } else {
        this.fallbackCopy(url, done);
      }
    }

    fallbackCopy(text, done) {
      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(input);
      done();
    }

    initGallery(gallery) {
      const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
      const thumbs = gallery.querySelector('[data-gallery-thumbs]');
      if (!items.length) return;

      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(items, thumbs, parseInt(item.dataset.index, 10) || 0);
        });
      });
    }

    colorScheme() {
      return Array.from(this.classList).find((c) => c.indexOf('color-scheme') === 0) || '';
    }

    open(items, thumbs, index) {
      const item = items[index];
      if (!window.theme || !window.theme.LoadPhotoswipe || !document.querySelector('.pswp')) {
        window.location.href = item.href;
        return;
      }

      const slides = items.map((el) => {
        const img = el.querySelector('img');
        return {
          src: el.dataset.src,
          msrc: img ? img.currentSrc || img.src : el.dataset.src,
          w: parseInt(el.dataset.width, 10) || 2400,
          h: parseInt(el.dataset.height, 10) || 1600
        };
      });

      const scheme = this.colorScheme();
      new window.theme.LoadPhotoswipe(slides, {
        history: false,
        focus: false,
        index: index,
        mainClass: 'pswp-zoom-gallery pswp--article' + (slides.length === 1 ? ' pswp-zoom-gallery--single' : '') + (scheme ? ' ' + scheme : ''),
        showHideOpacity: true,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close', 'title'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        getThumbBoundsFn: () => {
          const rect = item.getBoundingClientRect();
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + scrollY, w: rect.width };
        }
      });

      const holder = document.querySelector('.pswp__thumbs');
      if (holder && thumbs) holder.innerHTML = thumbs.innerHTML;
    }
  }

  customElements.define('article-editorial', ArticleEditorial);
})();
